import { alpha } from '@mui/material/styles';
import palette from './palette';

// Modern minimal shadows — soft, layered, very subtle
const color = palette.grey[900];

export default function shadows() {
  const s = (a) => alpha(color, a);
  return [
    'none',
    `0 1px 2px 0 ${s(0.05)}`,
    `0 1px 3px 0 ${s(0.06)}, 0 1px 2px 0 ${s(0.04)}`,
    `0 2px 4px 0 ${s(0.06)}, 0 1px 2px 0 ${s(0.04)}`,
    `0 4px 6px -1px ${s(0.08)}, 0 2px 4px -1px ${s(0.04)}`,
    `0 6px 10px -2px ${s(0.08)}, 0 2px 6px -1px ${s(0.04)}`,
    `0 8px 14px -3px ${s(0.08)}, 0 4px 8px -2px ${s(0.04)}`,
    `0 10px 18px -3px ${s(0.10)}, 0 4px 10px -2px ${s(0.04)}`,
    `0 12px 22px -4px ${s(0.10)}, 0 6px 12px -2px ${s(0.04)}`,
    `0 14px 26px -5px ${s(0.10)}, 0 6px 14px -3px ${s(0.04)}`,
    `0 16px 30px -6px ${s(0.12)}, 0 8px 16px -3px ${s(0.04)}`,
    `0 18px 34px -7px ${s(0.12)}, 0 8px 18px -4px ${s(0.04)}`,
    `0 20px 38px -8px ${s(0.12)}, 0 10px 20px -4px ${s(0.04)}`,
    `0 22px 42px -9px ${s(0.14)}, 0 10px 22px -5px ${s(0.04)}`,
    `0 24px 46px -10px ${s(0.14)}, 0 12px 24px -5px ${s(0.04)}`,
    `0 26px 50px -11px ${s(0.16)}, 0 12px 26px -6px ${s(0.04)}`,
    `0 28px 54px -12px ${s(0.16)}, 0 14px 28px -6px ${s(0.04)}`,
    `0 30px 58px -13px ${s(0.18)}, 0 14px 30px -7px ${s(0.04)}`,
    `0 32px 62px -14px ${s(0.18)}, 0 16px 32px -7px ${s(0.04)}`,
    `0 34px 66px -15px ${s(0.20)}, 0 16px 34px -8px ${s(0.04)}`,
    `0 36px 70px -16px ${s(0.20)}, 0 18px 36px -8px ${s(0.04)}`,
    `0 38px 74px -17px ${s(0.22)}, 0 18px 38px -9px ${s(0.04)}`,
    `0 40px 78px -18px ${s(0.22)}, 0 20px 40px -9px ${s(0.04)}`,
    `0 42px 82px -19px ${s(0.24)}, 0 20px 42px -10px ${s(0.04)}`,
    `0 44px 86px -20px ${s(0.24)}, 0 22px 44px -10px ${s(0.04)}`,
  ];
}
